import { InternalLink } from './types'

const commonTlds = ['com', 'org', 'net', 'int', 'edu', 'gov', 'mil', 'app']

const includesCommonTld = (text: string): boolean =>
  text.includes('localhost') || commonTlds.some(tld => text.includes(`.${tld}`))

export const getValidUrl = (text: string, isRetry?: boolean): string | null => {
  let isValid = false
  if (!includesCommonTld(text)) return null
  if (text.includes('@')) return null
  try {
    new URL(text)
    isValid = true
  } catch (_e) {
    if (!isRetry && includesCommonTld(text)) {
      return getValidUrl(`https://${text}`, true)
    }
    isValid = false
  }
  return isValid ? text : null
}
export const isUrl = (text: string, isRetry?: boolean): boolean =>
  getValidUrl(text, isRetry) !== null

const hbSites = [
  'hamiltonbilling.com',
  'hamiltonbilling-staging.web.app',
  'hbportal-staging.web.app',
  'localhost',
]

export const isHBPathname = (hostname: string) => hbSites.includes(hostname)
export const isHBSite = (url: string) => {
  try {
    const { hostname } = new URL(url)
    return isHBPathname(hostname)
  } catch (_e) {
    return false
  }
}

export const deconstructHref = (href: string) => {
  const validUrl = getValidUrl(href)
  if (!validUrl) throw new Error('Invalid URL')
  const url = new URL(validUrl)
  return {
    hostname: url.hostname,
    pathname: url.pathname,
  }
}

export const getInternalLink = (pathname: string): InternalLink | null => {
  let normalized = pathname.startsWith('/admin') ? pathname.slice(6) : pathname

  normalized = pathname.startsWith('/super-admin') ? pathname.slice(12) : normalized

  const [type, id = '', id2 = ''] = normalized.split('/').filter(i => !!i)
  switch (type) {
    case 'assessments':
      return { type: 'assessments', id }
    case 'patients':
      return { type: 'patients', id }
    case 'practices':
      return { type: 'practices', id }
    case 'invoices':
      return { type: 'invoices', id: id2 }
    case 'admins':
      return { type: 'admins', id }
    case 'assessment':
      return { type: 'your-assessment', id }
    default:
      return null
  }
}
